import React from 'react';
import PropTypes from 'prop-types';

export const IconFavorite = ({ className }) => (
  <svg className={className} width="20" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className="icon-filled-path"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0001 0.36615C10.3555 0.36615 10.6789 0.577449 10.8299 0.908356L13.2332 6.17429L18.5889 7.02096C18.9284 7.07463 19.2102 7.31902 19.319 7.65412C19.4279 7.98921 19.3455 8.35877 19.1055 8.61156L15.2041 12.7215L16.1266 18.5391C16.1831 18.8955 16.0368 19.2538 15.7498 19.4617C15.4628 19.6697 15.0855 19.6907 14.7783 19.516L10.0001 16.7982L5.22187 19.516C4.91466 19.6907 4.5374 19.6697 4.25039 19.4617C3.96338 19.2538 3.81705 18.8955 3.87356 18.5391L4.7961 12.7215L0.894676 8.61156C0.654713 8.35877 0.572285 7.98921 0.681123 7.65412C0.789962 7.31902 1.0718 7.07463 1.4113 7.02096L6.76701 6.17429L9.17029 0.908356C9.32131 0.577449 9.64468 0.36615 10.0001 0.36615ZM10.0001 3.52784L8.21897 7.43051C8.0892 7.71486 7.83028 7.91406 7.52843 7.96177L3.4519 8.60622L6.4312 11.7448C6.63453 11.959 6.72688 12.2598 6.68003 12.5552L5.98692 16.926L9.55649 14.8957C9.83252 14.7387 10.1676 14.7387 10.4437 14.8957L14.0132 16.926L13.3201 12.5552C13.2733 12.2598 13.3656 11.959 13.569 11.7448L16.5483 8.60622L12.4717 7.96177C12.1699 7.91406 11.911 7.71486 11.7812 7.43051L10.0001 3.52784Z"
      fill="#A3ACB3"
    />
  </svg>
);

IconFavorite.propTypes = {
  className: PropTypes.string
};

IconFavorite.defaultProps = {
  className: ''
};
